import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HammaddeService {

constructor(private http:HttpClient) { }



getHammaddeler(page:number){
  return this.http.get<any[]>(environment.apiUrl+"material?page="+page);
}

getAllergens(){
  return this.http.get<any[]>(environment.apiUrl+"material/allergens");
}

addAllergens(id){
  return this.http.get<any>(environment.apiUrl+"material/allergens/add?id="+id);
}

removeAllergens(id){
  return this.http.get<any>(environment.apiUrl+"material/allergens/reove?id="+id);
}


search(query:string,page:number){
  return this.http.get<any[]>(environment.apiUrl+"material/search?query="+query+"&page="+page);
}

searchAllergen(query:string){
  return this.http.get<any[]>(environment.apiUrl+"material/search?query="+query);
}

addHammadde(model:any){
return this.http.post(environment.apiUrl+"material",model);
}

editHammadde(model:any,id:any){
  return this.http.put(environment.apiUrl+"material/"+id,model);
  }

deleteHammadde(id:any){
  return this.http.delete(environment.apiUrl+"material/"+id);
  }

}
